import { render, staticRenderFns } from "./CarShopEditor.vue?vue&type=template&id=634d0bcb&scoped=true"
import script from "./CarShopEditor.vue?vue&type=script&lang=ts"
export * from "./CarShopEditor.vue?vue&type=script&lang=ts"
import style0 from "./CarShopEditor.vue?vue&type=style&index=0&id=634d0bcb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634d0bcb",
  null
  
)

export default component.exports